import { render, staticRenderFns } from "./restituirSaldoValePaciente.vue?vue&type=template&id=2e5288d1&scoped=true"
import script from "./restituirSaldoValePaciente.vue?vue&type=script&lang=js"
export * from "./restituirSaldoValePaciente.vue?vue&type=script&lang=js"
import style0 from "./restituirSaldoValePaciente.vue?vue&type=style&index=0&id=2e5288d1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e5288d1",
  null
  
)

export default component.exports